var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"d-lg-flex justify-lg-space-between px-0 px-md-2"},[_c('assets-widget',{staticClass:"mb-3 mb-lg-0 me-lg-5"}),_c('transactions-widget')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }